<template>
  <div>
    <crud-grades @displayBandsIntro="goToIntro"></crud-grades>
    <bottom-action-container>
      <btn-skip @navClicked="continuee"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="previous"/>
          <btn text="Next" type="primary" @click="continuee"/>
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>
<script>
import CrudGrades from './crud_salary_grades.vue'
export default {
  name: 'Grades',
  components: {
    CrudGrades
  },
  methods: {

    /* function to show intro */
    goToIntro() {
      this.$emit('displayIntro');
    },

    /* function to go back to previous page */
    previous() {
      this.$router.push(`/onboarding/entity/${this.$route.params.entity_index}/level`)
    },

    /* function to go to next page */
    continuee() {
      this.$router.push(`/onboarding/entity/${this.$route.params.entity_index}/empCategories`)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/scss/components/form.scss";
</style>
